module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_2_m.c21cf678b9f29fa0482b93650e2f4cd0.png";